(function () {
  const popup = document.querySelector('[data-guide-quote-popup]');
  if (!popup) return;

  const STORAGE_KEYS = {
    quoteSubmitted: 'guide_quote_submitted',
    quoteDismissedAt: 'guide_quote_popup_dismissed_at',
    sharedDismissedAt: 'site_popup_dismissed_at',
    sampleDismissedAt: 'sample_popup_dismissed_at',
    sessionShown: 'guide_quote_popup_shown',
  };
  const DISMISS_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;
  const TIME_TRIGGER_MS = 22000;
  const SCROLL_TRIGGER = 0.45;
  const MOBILE_BREAKPOINT = 749;
  const closeButtons = popup.querySelectorAll('[data-guide-quote-close]');
  const cta = popup.querySelector('[data-guide-quote-cta]');
  const pageSource = popup.dataset.pageSource || '';
  let isOpen = false;
  let hasTriggered = false;
  let previousFocus = null;
  let timeTrigger = null;

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // The popup still works when browser storage is unavailable.
    }
  }

  function wasDismissedRecently(key) {
    const dismissedAt = Number(safeGet(localStorage, key));
    return dismissedAt > 0 && Date.now() - dismissedAt < DISMISS_WINDOW_MS;
  }

  function isEligibleTraffic() {
    const params = new URLSearchParams(window.location.search);
    const medium = (params.get('utm_medium') || '').toLowerCase();
    const paidMedium = /(^|[_-])(cpc|ppc|paid|display|cpm|cpv)([_-]|$)/.test(medium);
    if (paidMedium || params.has('gclid') || params.has('msclkid')) return false;

    if (medium) {
      return medium === 'organic' || medium === 'referral' || medium === 'referrer';
    }

    if (
      params.has('utm_source') ||
      params.has('utm_campaign') ||
      params.has('utm_term') ||
      params.has('utm_content')
    ) {
      return false;
    }

    // Untagged visits are direct, organic/referral traffic, or an internal
    // continuation of one of those visits.
    return true;
  }

  function isSuppressed() {
    return (
      safeGet(localStorage, STORAGE_KEYS.quoteSubmitted) === 'true' ||
      safeGet(sessionStorage, STORAGE_KEYS.sessionShown) === 'true' ||
      wasDismissedRecently(STORAGE_KEYS.quoteDismissedAt) ||
      wasDismissedRecently(STORAGE_KEYS.sharedDismissedAt) ||
      wasDismissedRecently(STORAGE_KEYS.sampleDismissedAt) ||
      !isEligibleTraffic()
    );
  }

  function getFocusableElements() {
    return Array.from(
      popup.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter((element) => element.offsetParent !== null);
  }

  function openPopup() {
    if (isOpen || hasTriggered || isSuppressed()) return;

    hasTriggered = true;
    isOpen = true;
    previousFocus = document.activeElement;
    safeSet(sessionStorage, STORAGE_KEYS.sessionShown, 'true');
    window.clearTimeout(timeTrigger);
    window.removeEventListener('scroll', onScroll);

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('guide-quote-popup-open');

    window.requestAnimationFrame(() => {
      popup.classList.add('is-visible');
      const focusable = getFocusableElements();
      if (focusable.length) focusable[0].focus();
    });

    document.addEventListener('keydown', onKeydown);
  }

  function closePopup() {
    if (!isOpen) return;

    isOpen = false;
    const dismissedAt = String(Date.now());
    safeSet(localStorage, STORAGE_KEYS.quoteDismissedAt, dismissedAt);
    safeSet(localStorage, STORAGE_KEYS.sharedDismissedAt, dismissedAt);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('guide-quote-popup-open');
    document.removeEventListener('keydown', onKeydown);

    window.setTimeout(() => {
      if (!isOpen) popup.hidden = true;
    }, 220);

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closePopup();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onScroll() {
    const pageHeight = document.documentElement.scrollHeight;
    if (!pageHeight) return;

    const depth = (window.scrollY + window.innerHeight) / pageHeight;
    if (depth >= SCROLL_TRIGGER) openPopup();
  }

  function onCtaClick() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'popup_cta_click',
      popup: 'guide_page_quote',
      page: pageSource,
    });
  }

  function init() {
    if (isSuppressed()) return;

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    if (cta) cta.addEventListener('click', onCtaClick);

    popup.addEventListener('click', (event) => {
      if (event.target === popup && !window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches) {
        closePopup();
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    timeTrigger = window.setTimeout(openPopup, TIME_TRIGGER_MS);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
